import { render, staticRenderFns } from "./ColorSelect.vue?vue&type=template&id=ae58ed3a"
import script from "./ColorSelect.vue?vue&type=script&lang=js"
export * from "./ColorSelect.vue?vue&type=script&lang=js"
import style0 from "./ColorSelect.vue?vue&type=style&index=0&id=ae58ed3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports